import { useServiceToken } from '@ltvco/refresh-lib/v1';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Loading } from 'components/idMonitor/Loading';
import { NotificationAlertsSummaries } from 'components/idMonitor/NotificationsAlertsSummaries';
import { sessionEscalationURL } from 'components/idMonitor/Oxford/constants';
import { useOxford } from 'components/idMonitor/Oxford/Oxford';

export const AlertDetails = () => {
  const navigate = useNavigate();

  const { isError: isServiceTokenError } = useServiceToken(
    'oxford',
    sessionEscalationURL
  );

  const {
    data,
    isError: isNotificationsError,
    markAllNotificationsAsDisplayed,
  } = useOxford().useNotifications();

  if (isNotificationsError || isServiceTokenError) {
    navigate('/dashboard/id-monitor?escalated=true');
  }

  useEffect(() => {
    if (data) {
      markAllNotificationsAsDisplayed();
    }
  }, [data]);

  if (data) {
    return (
      <NotificationAlertsSummaries
        notifications={data?.notifications.notifications}
      />
    );
  }

  return <Loading />;
};
